module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/aq416-35cdddc6360dae78db016f3aad1d670f.jpg";